module.exports = __webpack_public_path__ + "static/media/layout6-img.e7f7112f.svg";